import { store } from '@returnmates/client-core/src/store/configureStore';
import { useEffect } from 'react';
function useSubscription(callApiSubscription, action, dataName, onSubscriptionCalled) {
    useEffect(function () {
        var subscriber = callApiSubscription();
        if (subscriber) {
            try {
                var subscribe_1 = subscriber === null || subscriber === void 0 ? void 0 : subscriber.subscribe(function (val) {
                    var _a, _b;
                    store.dispatch(action.success((_a = val.data) === null || _a === void 0 ? void 0 : _a[dataName]));
                    if ((_b = val.data) === null || _b === void 0 ? void 0 : _b[dataName]) {
                        onSubscriptionCalled === null || onSubscriptionCalled === void 0 ? void 0 : onSubscriptionCalled(val.data[dataName]);
                    }
                });
                return function () {
                    subscribe_1.unsubscribe();
                };
            }
            catch (err) {
                console.error("Something go wrong during ".concat(action.type, " subscription"), err);
                store.dispatch(action.failed());
            }
        }
    }, [callApiSubscription, action, dataName, onSubscriptionCalled]);
}
export default useSubscription;
//# sourceMappingURL=useSubscription.js.map